"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var setHeight = function setHeight(initialHeight, targetHeight, element, duration, onEndAnimate) {
  // Get total difference in height
  var heightDifference = targetHeight - initialHeight;
  var currentTime = null;
  var animateHeight = function animateHeight(timestamp) {
    // Set currentTime to 0 if not already set
    if (!currentTime) currentTime = timestamp;
    // Check how much time has elapsed
    var progress = timestamp - currentTime;
    // Calculates a new height based on how much time is left in the animation
    var newHeight = Number(progress / duration * heightDifference + initialHeight);
    // Sets new height inline
    element.setAttribute('style', "height: ".concat(newHeight, "px;"));

    // Check if animation has finished
    if (progress >= duration) {
      element.removeAttribute('style');
      onEndAnimate();
      return;
    }

    // Run again if not finished
    window.requestAnimationFrame(animateHeight);
  };
  window.requestAnimationFrame(animateHeight);
};
var _default = setHeight;
exports["default"] = _default;